import { render, staticRenderFns } from "./rolesManage.vue?vue&type=template&id=1bafd402&scoped=true&"
import script from "./rolesManage.vue?vue&type=script&lang=js&"
export * from "./rolesManage.vue?vue&type=script&lang=js&"
import style0 from "./rolesManage.vue?vue&type=style&index=0&id=1bafd402&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bafd402",
  null
  
)

component.options.__file = "rolesManage.vue"
export default component.exports